import isMobile from 'is-mobile';

export default isMobile({ tablet: true, featureDetect: true });
